













































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { ValidationProvider } from 'vee-validate-3';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import ColorPicker from '@/componentsV2/molecules/ColorPicker/ColorPicker.vue';
import UploadIcon from '@/components/icons/Upload.vue';
import BrandedCoinUpload from '@/componentsV2/molecules/Inputs/BrandedCoinUpload.vue';

import { SmartBusinessSignupData } from '@/models/smart-business-signup';
import CoinFrontAndBack from '@/views/YourCoin/CoinImage/CoinFrontAndBack.vue';

import SectionHeader from './SectionHeader.vue';
import { DEFAULT_BRANDED_COIN_IMAGE } from '../Constants';
import segmentIo from '@/utils/segment.io';

const ON_CHANGE_KEY = 'generateBrandedCoins';

@Component({
  components: {
    Typography,
    SectionHeader,
    ColorPicker,
    ValidationProvider,
    UploadIcon,
    BrandedCoinUpload,
    CoinFrontAndBack
  }
})
export default class BrandedCoin extends Vue {
  @Prop({ default: [] }) images!: string[];

  formData = this.smartBusinessSignupData.generateBrandedCoins;

  brandedCoinUpload = this.smartBusinessSignupData.generateBrandedCoins
    .brandedCoinSelected.url;

  errors: string[] = [];

  get smartBusinessSignupData(): SmartBusinessSignupData {
    return this.$store.getters['businessOnboarding/getSmartBusinessSignup'];
  }

  get showBrandedCoinPlaceholder(): boolean {
    return this.images[0] === DEFAULT_BRANDED_COIN_IMAGE;
  }

  get defaultBrandedCoin() {
    if (
      this.smartBusinessSignupData.generateBrandedCoins.images.includes(
        this.brandedCoinUpload
      )
    )
      return undefined;
    return {
      imageUrl: this.brandedCoinUpload
    };
  }

  get selectedBranded() {
    return {
      ...this.formData,
      image: { ...this.formData.brandedCoinSelected }
    };
  }

  onChangeEmit() {
    this.$emit('onChange', this.formData, ON_CHANGE_KEY);
  }

  onSelectImage(image: string) {
    this.formData.brandedCoinSelected.url = image;
    this.formData.brandedCoinSelected.id = '';
    this.brandedCoinUpload = '';
    this.onChangeEmit();
    this.clearError('branded-coin-image');

    segmentIo.track('AI Sign Up | Branded Coin Selected', {
      'Image URL': this.formData.brandedCoinSelected.url
    });
  }

  onUploadImage(response: any) {
    this.formData.brandedCoinSelected.url = response.link;
    if (response.id) this.formData.brandedCoinSelected.id = response.id;

    this.brandedCoinUpload = response.link;
    this.onChangeEmit();
    this.clearError('branded-coin-image');
    if (response.id)
      segmentIo.track('AI Sign Up | Branded Coin Uploaded', {
        'Image URL': this.formData.brandedCoinSelected.url
      });
  }

  onDeleteImage() {
    this.formData.brandedCoinSelected =
      this.brandedCoinUpload === this.formData.brandedCoinSelected.url
        ? { url: '' }
        : this.formData.brandedCoinSelected;

    this.onSelectImage(this.images[0]);
  }

  clearError(field: string) {
    this.errors = this.errors.filter(eachField => eachField !== field);
  }

  handleColorPickerInput(colorhex: string, colorKey: string) {
    this.formData.colorKey = colorKey;
    this.onChangeEmit();

    segmentIo.track('AI Sign Up | Branded Coin Color Selected', {
      'Color Key': colorKey
    });
  }
}
